import { fetchAuthSession } from "aws-amplify/auth";
import { get } from "aws-amplify/api";
import { useQuery } from "react-query";

export const APPOINTMENTS_QUERY_KEY = "APPOINTMENTS_QUERY_KEY";

export const useAppointmentsQuery = (patientUserId) => {
  return useQuery({
    queryKey: [APPOINTMENTS_QUERY_KEY, patientUserId],
    retry: false,
    queryFn: listAppointments.bind(this, patientUserId),
    staleTime: Infinity,
    placeholderData: [],
    enabled: !!patientUserId,
  });
};

export const useAppointmentQuery = (patientUserId, id) => {
  return useQuery({
    queryKey: [APPOINTMENTS_QUERY_KEY, patientUserId],
    retry: false,
    queryFn: listAppointments.bind(this, patientUserId),
    staleTime: Infinity,
    placeholderData: [],
    select: (appointment) => appointment.filter((ap) => ap.id === id)[0],
    enabled: !!patientUserId,
  });
};

const listAppointments = async (patientUserId) => {
  const session = await fetchAuthSession();
  const { body } = await get({
    apiName: "appointmentsapi",
    path: "/" + patientUserId,
    options: {
      headers: {
        Authorization: session.tokens.idToken.toString(),
      },
    },
  }).response;
  return await body.json();
};
